module.exports = __webpack_public_path__ + "static/media/calcCardsLogo.d088e79b.svg";